/** Query parameter on public booking URLs linking to a staff-created student invite token. */
export const STUDENT_INVITE_QUERY_PARAM = 'studentInvite' as const;

/** Days from token issue until guardian attach via invite link is rejected (server-enforced). */
export const MANUAL_STUDENT_INVITE_TOKEN_TTL_DAYS = 30 as const;
